import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { getActiveTenantId } from "@/shared/tenant/active-tenant";
import type { OutboxEvent, Paginated, SequenceSummary } from "@/features/campaigns/types";

// /api/sequences and /api/events are paginated ({ items, total, page, pageSize }, cap 100).
// These global pages render a flat list, so we ask for the max page and unwrap `.items`
// for the array-consuming callers. Revisit with page controls if volumes outgrow 100.
const LIST_PAGE_SIZE = 100;

/** GET /api/sequences — every sequence across the tenant's campaigns (newest 100). */
export function useAllSequences() {
  return useQuery({
    queryKey: ["sequences", getActiveTenantId(), "all"] as const,
    queryFn: async () =>
      (await httpClient<Paginated<SequenceSummary>>(`/api/sequences?pageSize=${LIST_PAGE_SIZE}`)).items,
  });
}

/** GET /api/events — the global Outbox (recent delivery events, tenant-wide, newest 100). */
export function useOutbox() {
  return useQuery({
    queryKey: ["outbox", getActiveTenantId()] as const,
    queryFn: async () =>
      (await httpClient<Paginated<OutboxEvent>>(`/api/events?pageSize=${LIST_PAGE_SIZE}`)).items,
  });
}
